(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/actions.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/actions.js');

svs.ticket_partner.digitalTickets.actions = {
  UPDATE_ARTICLES: 'UPDATE_ARTICLES',
  UPDATE_BILLING_INFORMATION: 'UPDATE_BILLING_INFORMATION',
  UPDATE_REGISTER_INFORMATION: 'UPDATE_REGISTER_INFORMATION',
  RECEIVE_COMPANY_DETAILS: 'RECEIVE_COMPANY_DETAILS',
  CLEAR_STATE: 'CLEAR_STATE',
  ORDER_SUCCESS: 'ORDER_SUCCESS'
};


 })(window);